import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { saveAs } from 'file-saver';
import { HttpService } from 'src/app/service/http/http.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-generate-incrementletters-preview-popup',
  templateUrl: './generate-incrementletters-preview-popup.component.html',
  styleUrls: ['./generate-incrementletters-preview-popup.component.scss'],
})
export class GenerateIncrementlettersPreviewPopupComponent implements OnInit {
  employeeName: any;
  userId: any;
  letterUrl: any;
  currentIndex: number = 0;
  incrementLetterData: any[] = [];
  moduleName: any;
  vpInputPayload:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private config: Config, private httpService: HttpService,
    private sanitizer: DomSanitizer, private loader: LoaderService,
    private dialogRef: MatDialogRef<GenerateIncrementlettersPreviewPopupComponent>) { }

  ngOnInit() {
    this.employeeName = this.data.userName;
    this.userId = this.data.userId;
    this.incrementLetterData = this.data.incrementLetterData;
    this.moduleName = this.data?.moduleName;
    this.vpInputPayload = this.data?.vpInputPayload;
    this.currentIndex = this.incrementLetterData.findIndex(employee => employee.inputId === this.userId);

    if (this.employeeName && this.userId) {
      if (this.moduleName == 'Increment') {
        this.viewIncrementLetter();
      }else{
        this.viewVPLetter();
      }
    }
  }

  viewIncrementLetter() {
    const request = { "id": [this.userId] };

    this.httpService.callPostService(this.config.getLetterOfUsers, request).subscribe(
      (result: any) => {
        if (result?.data != null) {
          // const googleDocsUrl = `https://docs.google.com/gview?embedded=true&url=${result?.data}`;
          this.letterUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result?.data);
        } else {
          this.letterUrl = null
        }
      },
      (error: any) => {
        if (error.status === 500) {
          this.dialogRef.close();
        }
      }
    );
  }
  viewVPLetter() {
    const request = {
      "companyId": this.vpInputPayload.companyId,
      "frequencyCycle": this.vpInputPayload.frequencyCycle,
      "fromYear": this.vpInputPayload.fromYear,
      "toYear": this.vpInputPayload.toYear,
      "userId": [this.userId]
    };

    this.httpService.callPostService(this.config.VPgetLetterOfUsers, request).subscribe(
      (result: any) => {
        if (result?.data != null) {
          // const googleDocsUrl = `https://docs.google.com/gview?embedded=true&url=${result?.data}`;
          this.letterUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result?.data);
        } else {
          this.letterUrl = null
        }
      },
      (error: any) => {
        if (error.status === 500) {
          // this.dialogRef.close();
        }
      }
    );
  }
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') {
      this.showPreviousLetter();
    } else if (event.key === 'ArrowRight') {
      this.showNextLetter();
    }
  }

  showPreviousLetter() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateLetterDisplay();
    }
  }

  showNextLetter() {
    if (this.currentIndex < this.incrementLetterData.length - 1) {
      this.currentIndex++;
      this.updateLetterDisplay();
    }
  }

  updateLetterDisplay() {
    if (this.incrementLetterData.length === 0 || this.currentIndex < 0 || this.currentIndex >= this.incrementLetterData.length) {
      console.error("No letter data available.");
      return;
    }

    const currentEmployee = this.incrementLetterData[this.currentIndex];
    this.employeeName = currentEmployee.employeeName;
    this.userId = currentEmployee.inputId;

    if (!this.userId) {
      console.error("Invalid user ID, cannot fetch letter.");
      return;
    }
    if (this.moduleName == 'Increment') {
      this.viewIncrementLetter();
    }else{
      this.viewVPLetter();
    }
  }


  onClickDownloadLetter() {
    if (this.moduleName == 'Increment') {
      this.downloadIncrementLetter();
    }else{
      this.downloadVpLetter();
    }
  }
  downloadIncrementLetter() {
    const request = {
      "id": [this.userId]
    }
    this.httpService.callPostService(this.config.getLetterOfUsers, request).subscribe((result: any) => {
      const downloadFile: any = result.data;
      if (result?.data != null) {
        var fileName = result?.data?.split(environment.downloadURL)
        saveAs(result?.data, fileName[1]);
      }
    })
  }
  downloadVpLetter(){
    const request = {
      "companyId": this.vpInputPayload.companyId,
      "frequencyCycle": this.vpInputPayload.frequencyCycle,
      "fromYear": this.vpInputPayload.fromYear,
      "toYear": this.vpInputPayload.toYear,
      "userId": [this.userId]
    };
    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.VPgetLetterOfUsers, request).subscribe((result: any) => {
      if(result?.data!=null){
        saveAs(result?.data, 'VariablePayLetter'); 
      }
      this.loader.dismissLoader();
    });
  }
}
